import React, { useState } from "react";
import { useOnboarding } from "../../../contexts/OnboardingContext";
import { FREDOKA, NO, Mascot, StepHeading, ContinueSlot, ContinueButton } from "../NOKit";

// iOS NOChildNameStep port: name + age on one screen. Both required.
const AGES = ["3", "4", "5", "6", "7", "8", "9+"];

const NameAgeStep = () => {
  const { username, setUsername, childAge, setChildAge, nextStep } = useOnboarding();
  const [name, setName] = useState(username || "");

  const canContinue = name.trim().length > 0 && !!childAge;

  const handleContinue = () => {
    if (!canContinue) return;
    setUsername(name.trim());
    nextStep();
  };

  return (
    <div className="w-full max-w-xl mx-auto flex flex-col items-center px-4 animate-fadeIn">
      <Mascot size={110} clip="panda_paint" />
      <div className="w-full" style={{ marginTop: 16 }}>
        <StepHeading eyebrow="First, a name" title="What's your child's" accent="name?" />
      </div>

      <div className="w-full" style={{ marginTop: 22 }}>
        <input
          type="text"
          value={name}
          maxLength={20}
          autoFocus
          placeholder="Type name here…"
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleContinue();
          }}
          className="w-full"
          style={{
            ...FREDOKA,
            fontSize: 20,
            fontWeight: 600,
            color: NO.ink,
            background: "#FFFFFF",
            padding: "16px 18px",
            borderRadius: 16,
            border: `2px solid ${NO.track}`,
            outline: "none",
            boxShadow: "0 4px 8px rgba(0,0,0,0.04)",
          }}
          onFocus={(e) => (e.target.style.border = `2px solid ${NO.accent}`)}
          onBlur={(e) => (e.target.style.border = `2px solid ${NO.track}`)}
        />
        <div
          className="text-right"
          style={{ ...FREDOKA, color: NO.subtitle, fontSize: 12, marginTop: 6 }}
        >
          {name.length}/20
        </div>
      </div>

      <div className="w-full" style={{ marginTop: 10 }}>
        <div style={{ ...FREDOKA, color: NO.ink, fontWeight: 700, fontSize: 19 }}>
          How old are they?
        </div>
        <div className="grid grid-cols-4 sm:grid-cols-7 gap-2" style={{ marginTop: 12 }}>
          {AGES.map((age) => {
            const selected = childAge === age;
            return (
              <button
                key={age}
                type="button"
                onClick={() => setChildAge(age)}
                className="transition active:scale-[0.95]"
                style={{
                  ...FREDOKA,
                  height: 56,
                  borderRadius: 14,
                  fontSize: 19,
                  fontWeight: 700,
                  border: selected ? "none" : `1px solid ${NO.cardStroke}`,
                  background: selected ? NO.accent : "#FFFFFF",
                  color: selected ? "#FFFFFF" : NO.ink,
                  boxShadow: selected
                    ? "0 6px 14px rgba(0,101,248,0.30)"
                    : "0 4px 8px rgba(0,0,0,0.04)",
                  transform: selected ? "scale(1.06)" : "none",
                  cursor: "pointer",
                }}
              >
                {age}
              </button>
            );
          })}
        </div>
      </div>

      <ContinueSlot>
        <ContinueButton onClick={handleContinue} disabled={!canContinue} />
      </ContinueSlot>
    </div>
  );
};

export default NameAgeStep;
